import { connect } from 'react-redux';
import Component from './AcceleratedTesters.component';
import { getCurrentRosterYear } from '../StudentRoster/+store/studentRoster';
import { getSchools } from '../Settings/+store/SchoolSettings';
import {
  getAcceleratedTesters,
  updateAcceleratedTesterOverride,
  updateAcceleratedTesterOverridesBulk,
  uploadAcceleratedTestersFile,
} from './+store';

const deriveFileYear = (acceleratedTesters) => {
  if (!acceleratedTesters) return null;
  const first = Object.values(acceleratedTesters).find((entry) => entry && entry.fileYear);
  return first ? Number(first.fileYear) : null;
};

const mapStateToProps = (state) => {
  const { profile } = state.modules.Auth.auth;
  const acceleratedTesters = state.modules.AcceleratedTesters.acceleratedTesters.acceleratedTesters || {};
  const snapshotYear = getCurrentRosterYear();
  return {
    profile,
    snapshotYear,
    fileYear: deriveFileYear(acceleratedTesters),
    acceleratedTesters,
    schoolList: state.modules.Settings.schoolSettings.schoolList,
    loading: !!state.modules.AcceleratedTesters.acceleratedTesters.loadingMsg,
    loadingMsg: state.modules.AcceleratedTesters.acceleratedTesters.loadingMsg,
    upload: state.modules.AcceleratedTesters.acceleratedTesters.upload,
  };
};

const mapDispatchToProps = (dispatch) => ({
  init: (profile) => {
    dispatch(getSchools(profile));
  },
  getAcceleratedTesters: (snapshotYear) => {
    dispatch(getAcceleratedTesters(snapshotYear));
  },
  updateOverride: (snapshotYear, firebaseId, override) => {
    dispatch(updateAcceleratedTesterOverride(snapshotYear, firebaseId, override));
  },
  updateOverridesBulk: (snapshotYear, updates) => {
    dispatch(updateAcceleratedTesterOverridesBulk(snapshotYear, updates));
  },
  uploadFile: (profile, file, snapshotYear) => {
    dispatch(uploadAcceleratedTestersFile(profile, file, snapshotYear));
  },
});

const Container = connect(mapStateToProps, mapDispatchToProps)(Component);

export default Container;
